export const calcDiffDate = (date: string) => {
  const givenDate = new Date(date).getTime();
  const currentDate = new Date().getTime();

  // Calculate the difference in milliseconds
  const diffInMilliseconds = currentDate - givenDate;

  // Convert the difference to days
  const diffInDays = diffInMilliseconds / (24 * 60 * 60 * 1000);

  return diffInDays;
};
